<template>
    <section class="assessmentSection doorsSection">
        <div class="welcomeBackground"></div>
        <div class="pageContent">
            <div class="pageCompleted">70% complete</div>
            <div class="pageTitle">What is an area of concern?</div>
            <div class="pageText">
                <p>
                    This is a part of your home you find vulnerable to intrusion. It could be a window in a hallway or every window in your living room.
                </p>
                <p v-if="lead.protectionLevel === 'Total'">
                    Total protection means protecting all accessible windows. To do this, we need to know how many areas in your home are accessible from the ground floor.
                </p>
            </div>

            <div v-if="lead.protectionLevel === 'Total'">
                <button v-if="!readyToAdd && !lead.accessibleAreasQty"
                        @click="handleContinueClick"
                        class="button">
                    Ok, got it
                </button>

                <transition name="fade">
                    <div class="formGroup doorsFormGroup"
                         v-if="readyToAdd || lead.accessibleAreasQty">
                        <label for="">How many areas are accessible from the ground floor?</label>
                        <input ref="input"
                               type="number"
                               pattern="[1-9]*"
                               min="1"
                               placeholder=""
                               @keydown="restrictToUnsignedInteger({
                                   event: $event
                               })"
                               v-model="lead.accessibleAreasQty" />
                    </div>
                </transition>
            </div>

            <transition name="fade">
                <continue-button :to="to"
                                 text="Start protecting areas of concern"
                                 v-if="lead.accessibleAreasQty || lead.protectionLevel !== 'Total'" />
            </transition>
        </div>
    </section>
</template>


<script>
import Vue from 'vue'
import { mapActions, mapState } from 'vuex'
export default {
    data() {
        return {
            readyToAdd: false
        }
    },

    computed: {
        ...mapState(['lead', 'previousRoute']),

        to() {
            let protectionLevel = this.lead.protectionLevel
            return '/assessment/areas-of-concern-intro'

            if (this.fromAdditionalEquipment) {
                return '/assessment/system'
            }
        }
    },
    methods: {
        ...mapActions([]),

        handleContinueClick() {
            this.readyToAdd = true
            Vue.nextTick(() => {
                this.$refs.input.focus()
            })
        },

        restrictToUnsignedInteger(event) {
            let value = event.target.value
            let isZero = event.keyCode === 48
            let isOneToNine = event.keyCode > 48 && event.keyCode < 58
            let isDelete = event.keyCode === 46
            let isBackspace = event.keyCode === 8
            let isEnter = event.keyCode === 13

            if (value) {
                if (
                    isZero ||
                    isOneToNine ||
                    isDelete ||
                    isBackspace ||
                    isEnter
                ) {
                    return
                }
                event.preventDefault()
            }

            if (!value) {
                if (isOneToNine || isDelete || isBackspace) {
                    return
                }
                event.preventDefault()
            }
        }
    },
    mounted() {
        this.$Progress.set(70)
        if (this.lead.accessibleAreasQty) {
            this.readyToAdd = true
        }
    },
    updated() {
        if (this.lead.accessibleAreasQty) {
            this.readyToAdd = true
        }
    }
}
</script>

<style lang="css"></style>
